<ng-template #notUpgradedMessage let-noUpgradesMessage="noUpgradesMessage">
  <div class="font-body-1 bold-type">{{ noUpgradesMessage | finLocalization }}</div>
</ng-template>

<ng-template #upgradeMessage let-flight="flight">
  <h4 class="bold-type font-body-1 ms-xsmall-b">
    <ng-container *ngIf="flight.cabin === Cabin.Business">
      {{ 'oneUpgrade.review.upgradeToBusiness' | finLocalization }}
    </ng-container>
    <ng-container *ngIf="flight.cabin === Cabin.Ecopremium">
      {{ 'oneUpgrade.review.upgradeToEcoPremium' | finLocalization }}
    </ng-container>
  </h4>

  <div class="upgrade-details flex flex--wrap">
    <p class="medium-type ps-medium-r">{{ printPrice(flight) | async }}</p>

    <p *ngIf="(selectedPassengers$ | async).length as selectedAmount" class="pax-amount">
      <ng-container [ngSwitch]="selectedAmount">
        <ng-container *ngSwitchCase="1"
          >({{ 'oneUpgrade.upgradeSelection.pricesForPassenger' | finLocalization }})</ng-container
        >
        <ng-container *ngSwitchDefault
          >({{
            'oneUpgrade.upgradeSelection.pricesForPassengers' | finLocalization: { passengerAmount: selectedAmount }
          }})</ng-container
        >
      </ng-container>
    </p>
  </div>

  <fcom-notification
    *ngIf="flight.isWaitlisted"
    [layout]="NotificationLayout.BLOCK"
    class="block ms-medium-t"
    [linkText]="'readMore' | finLocalization"
    (linkClick)="openModal($event, flight.segmentInfo.flightId)"
    data-testid="upgrade-waitlist-notification"
  >
    {{ 'oneUpgrade.notifications.waitlistedUpgrade' | finLocalization }}
  </fcom-notification>
</ng-template>

<div
  class="white-bg pr-medium border rounded-medium mobile-bleed ms-medium-b"
  *ngFor="let bounds of journeysWithUpgrades$ | async; let index = index; let last = last; let first = first"
  [class.mr-large-b]="!last"
  [class.mr-xsmall-b]="last"
>
  <fin-upgrade-journey-info
    [flightNumber]="index + 1"
    [isMultiCity]="(journeysWithUpgrades$ | async).length > 2"
    [bounds]="getAllBoundsForJourney(bounds) | async"
    [headingLevel]="2"
  >
  </fin-upgrade-journey-info>
  <div *ngFor="let flight of bounds; let last = last; let first = first" class="bound-list">
    <fin-upgrade-bound-card
      [attr.data-flight]="flight.segmentInfo.flightId"
      [flight]="flight"
      [allFlights]="bounds"
      [first]="first"
      [last]="last"
      [highlighted]="!flight.isBeingUpgraded"
      [bordered]="true"
    >
      <ng-container *ngIf="getNumberOfFlights(flight, bounds) as numberOfFlights">
        <div class="font-body-1 ps-xsmall-b" *ngIf="numberOfFlights > 1">
          {{ flight.segmentInfo.ordinal }}/{{ numberOfFlights }}
        </div>
      </ng-container>
      <div
        class="upgrade-details-wrapper fill"
        [ngClass]="flight.isBeingUpgraded ? 'ms-xsmall-t' : 'flex flex--middle'"
      >
        <ng-container
          [ngTemplateOutlet]="flight.isBeingUpgraded ? upgradeMessage : notUpgradedMessage"
          [ngTemplateOutletContext]="{
            flight: flight,
            noUpgradesMessage: flight.noUpgradesMessage,
          }"
        >
        </ng-container>
      </div>
    </fin-upgrade-bound-card>
  </div>

  <div class="align-right ps-medium-t" *ngIf="boundHasAvailableUpgrades(bounds)">
    <button
      data-change-bound
      class="font-body-1 bold-type nordic-blue-900-text underline blue-light-hover"
      (click)="onFlightsChange()"
    >
      {{ 'oneUpgrade.upgradeSelection.change' | finLocalization }}
    </button>
  </div>
</div>
